import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { IFormInfoOrderPayload } from "../types/order";
// import axiosSecondService, { AxiosSecondService } from "./axiosSecondService";
import axiosThirdService, { AxiosThirdService } from "./axiosThirdService";
class OrderService {
    // readonly service: AxiosSecondService
    // constructor() {
    //     this.service = axiosSecondService;
    // }
    readonly service: AxiosThirdService
    constructor() {
        this.service = axiosThirdService;
    }
    // async createOrder(payload: IFormInfoOrderPayload) {
    //     return this.service.post<any>(getPath(EP.AFFILIATE, EP.DROPSHIP, EP.CREATEORDER), payload)
    // }
    async createOrder(payload: IFormInfoOrderPayload) {
        return this.service.post<any>(getPath(EP.API, EP.V1, EP.ORDER, EP.CREATE), payload)
    }
}
const orderService = new OrderService();
export default orderService;